import React from 'react'
import { useStore } from '../../Hook/App';
import Layout from '../../Layout'
import Spinner from '../../Components/Spinner'
import Item from '../../Components/Item'
function Index() {
    const { tab, setTab, navigate, store, items, comments } = useStore();
    return (
        <Layout>
            {!store ? <div style={{ height: '100vh' }} className='d-flex align-items-center justify-content-center'>
                <Spinner />
            </div> :
                <>
                    <div className="singlestore-header">
                        <div className="header bg-white ">
                            <div><i className="arrow fas  text-dark fa-arrow-right" onClick={() => { navigate(-1) }}></i></div>
                            <div>
                                <i class="fas fa-share-alt text-dark "></i>
                            </div>
                        </div>
                        <div className="item-img">
                            <img src={store.logo} alt="no image" style={{ objectFit: "cover" }} />
                        </div>
                        <div className="item-icon">
                            <div>
                                <img src={store.logo} alt="no image" style={{ background: "#fff", objectFit: "cover" }} />
                            </div>
                        </div>
                        <div className="center">
                            <p>{store.name}</p>
                            <span> {items && items.total} آگهی</span>
                        </div>
                    </div>
                    <div className="singlestore-main">
                        <div className="d-flex justify-content-around bg-white">
                            <button onClick={() => setTab("items")} style={tab == "items" ? { borderBottomColor: "#2185e2" } : { border: "none" }} className='singlestore-title'>
                                <span style={tab == "items" ? { color: "#000" } : { color: "#81858b" }}>آگهی ها</span>
                            </button>
                            <button onClick={() => setTab("info")} style={tab == "info" ? { borderBottomColor: "#2185e2" } : { border: "none" }} className='singlestore-title'>
                                <span style={tab == "info" ? { color: "#000" } : { color: "#81858b" }}>اطلاعات فروشگاه</span>
                            </button>
                            <button onClick={() => setTab("comment")} style={tab == "comment" ? { borderBottomColor: "#2185e2" } : { border: "none" }} className='singlestore-title'>
                                <span style={tab == "comment" ? { color: "#000" } : { color: "#81858b" }}>نظرات</span>
                            </button>
                        </div>
                        {tab == "items" && <Items items={items} />}
                        {tab == "info" && <Information store={store} />}
                        {tab == "comment" && <Comment comments={comments} />}
                    </div>
                </>
            }
        </Layout>
    )
}

const Items = ({ items = [] }) => {
    return (
        <div className='main'>
            {items && items.data && items.data.map((item, i) => <Item item={item} key={i} link={"/item/" + item.id} />)}
        </div>
    )
}

const Information = ({ store }) => {
    return (
        <div className="p-2">
            <div className="info">
                <p>درباره فروشگاه</p>
                <span className="light">{store && store.meta_data && store.meta_data.description}</span>
            </div>{
                store && store.meta_data && store.meta_data.time || store.meta_data.phone || store.meta_data.address
                &&
                <div className="info">
                    <p>اطلاعات تماس</p>
                    {store.meta_data.time &&
                        <div className="d-flex justify-content-between mb-3">
                            <span className="light">ساعت کاری</span>
                            <span>{store.meta_data.time}</span>
                        </div>
                    }
                    {store.meta_data.phone &&
                        <div className="d-flex justify-content-between mb-3">
                            <span className="light">تلفن</span>
                            <span>{store.meta_data.phone}</span>
                        </div>
                    }
                    {store.meta_data.address &&
                        <div className="mb-3">
                            <p className="light">ادرس</p>
                            <span>{store.meta_data.address}</span>
                        </div>
                    }
                </div>
            }

        </div>

    )
}

const Comment = ({ comments }) => {

    return (
        <div className="p-2">
            {comments && comments.data && comments.data.map((comment, i) => {
                const Stars = () => {
                    let JSX = [];
                    for (let index = 0; index < 5; index++) {
                        JSX.push(<i style={{ color: (comment.score / 20) > index ? "#fc3" : "#ccc" }} class="fas fa-star"></i>);
                    }
                    return JSX

                }
                return (
                    <div key={i} className="comment">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                            <div className="align-items-center d-flex">
                                <i class="fas fa-thumbs-up"></i>
                                <div className="line light-text">{comment.user && comment.user.name}</div>
                                <span className="light-text">{new Date(comment.created_at).toLocaleDateString('fa')}</span>
                            </div>
                            <div className="d-flex" style={{ direction: 'ltr' }}>
                                <Stars />
                            </div>
                        </div>
                        <div className="d-flex mb-3">
                            <span className="light-text">برای</span>
                            <span className="margin">{comment.item && comment.item.name}</span>
                        </div>
                        <p>{comment.comment}</p>
                        {comment.answer &&
                            <>
                                <span className='d-block mx-2 mb-2'>پاسخ</span>
                                <p className='ms-3'>{comment.answer}</p>
                            </>
                        }
                        <div className="comment-footer d-flex justify-content-center">
                            <div className="line light-text d-flex">
                                <small> امتیاز کل {(comment.score / 20)} از 5</small>
                            </div>
                            <div className="line light-text d-flex">
                                <small>  سرعت پاسخگویی {(comment.speed / 20)} از 5</small>
                            </div>
                            <div className="light-text d-flex">
                                <small>   صحت اطلاعات {(comment.verify / 20)} از 5</small>
                            </div>
                        </div>
                    </div>
                )
            })}
        </div>

    )
}

export default Index
